// libraries
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import RoundedBox from '/react4xp/components/RoundedBox'
import Link from '/react4xp/components/Link'

// types
interface InfoCardProps {
    className?: string
    isAnimated?: boolean
    color?: 'green-light' | 'beige'
    title?: string
    intro?: string
    ctas?: {
        style?: 'link' | 'button'
        label?: string
        href?: {
            href?: string
            external?: boolean
        }
    }[]
}

// css
import './index.scss'

export default function InfoCard({
    className,
    isAnimated,
    color,
    title,
    intro,
    ctas
}: InfoCardProps) {
    return (
        <Section className={clsx(
            'info-card-component',
            className
        )}>
            <div
                className='container'
                data-stagger-up={isAnimated ? 'true' : 'false'}
            >
                <RoundedBox bgColor={color}>
                    <div className='row'>
                        <div className='col-lg-10 offset-lg-1 col-xl-6 offset-xl-3'>

                            {title && (
                                <h2 className='h2 info-card-component__title'>
                                    {title}
                                </h2>
                            )}

                            {intro && (
                                <div
                                    className='body info-card-component__intro'
                                    dangerouslySetInnerHTML={{
                                        __html: intro
                                    }}
                                />
                            )}

                            {ctas && (
                                <div className='info-card-component__ctas'>
                                    {ctas.map((item, i) => {
                                        if (item.style === 'link') {
                                            return (
                                                <Link
                                                    key={i}
                                                    href={item.href?.href}
                                                    isExternal={item.href?.external}
                                                    className='body'
                                                    icon={{
                                                        type: 'arrow-right'
                                                    }}
                                                    label={{
                                                        underline: item.label
                                                    }}
                                                />
                                            )
                                        } else {
                                            return (
                                                <a
                                                    key={i}
                                                    href={item.href?.href}
                                                    target={item.href?.external ? '_blank' : undefined}
                                                    rel={item.href?.external ? 'noopener noreferrer' : undefined}
                                                    className='button-hollow-black body'
                                                >
                                                    {item.label}
                                                </a>
                                            )
                                        }
                                    })}
                                </div>
                            )}

                        </div>
                    </div>
                </RoundedBox>
            </div>
        </Section>
    )
}